import Tile from 'features/tiles/tile';
import TileGridContainer from 'features/tiles/tileGridContainer';
import { FC, useMemo } from 'react';
import MmmHeaderControls from '../header-controls/mmm-header-controls';
import ChartBridge from 'features/charts/strategies/chart-bridge';
import Loading from 'common/components/loading/loading';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store';
import { createModelledRoiCharts } from './modelled-roi-charts';
import { useGetDataScienceMmmSegmentDataQuery } from 'app/apis/queryApi';

const MmmModelledRoiPage: FC<Record<string, unknown>> = () => {
  const { siteId } = useSelector((state: RootState) => state.selectedSite);
  const { selectedSegmentKey } = useSelector(
    (state: RootState) => state.mmmHeaderControls
  );

  const { data: mmmModelOutput, isFetching: isFetchingModelOutput } =
    useGetDataScienceMmmSegmentDataQuery(
      {
        siteId,
        segment: selectedSegmentKey
      },
      {
        skip: selectedSegmentKey.length < 1
      }
    );

  const charts = useMemo(() => {
    if (!isFetchingModelOutput && mmmModelOutput) {
      return createModelledRoiCharts(mmmModelOutput);
    }
  }, [mmmModelOutput, isFetchingModelOutput]);

  return (
    <div>
      <MmmHeaderControls />
      <TileGridContainer className="grid grid-cols-12 gap-3 mt-3">
        <div className="col-span-12">
          <h4 className="mb-1">Modelled ROI by Channel</h4>
          <Tile>
            <div className="px-2.5 pb-8 h-92">
              {charts && !isFetchingModelOutput ? (
                <ChartBridge chart={charts.modelledRoiByChannel} />
              ) : (
                <Loading />
              )}
            </div>
          </Tile>
        </div>
        {/* 
        <div className="col-span-12 lg:col-span-6">
          <h4 className="mb-1">Modelled ROI Combined</h4>
          <Tile>
            <div className="px-3 h-92">
              {charts && !isLoading ? (
                <ChartBridge chart={charts.modelledRoiGrouped} />
              ) : (
                <Loading />
              )}
            </div>
          </Tile>
        </div> */}
      </TileGridContainer>
    </div>
  );
};

export default MmmModelledRoiPage;
